import { IonIcon } from '@ionic/react';
import classNames from 'classnames';
import { checkmarkOutline } from 'ionicons/icons';
import React from 'react';

import { OptionCheckmarkStyles } from './OptionCheckmark.styles';

export const OptionCheckmark: React.FC<{
  checked: boolean;
  className?: string;
  theme?: 'light' | 'dark' | 'dark-forest' | 'domination';
}> = ({ checked, className, theme = 'light' }) => {
  return (
    <OptionCheckmarkStyles
      checked={checked}
      className={classNames(className)}
      theme={theme}
    >
      {checked && <IonIcon icon={checkmarkOutline} />}
    </OptionCheckmarkStyles>
  );
};
